import { TTemplateSettingKeys } from '../../api/blueprints/blueprint-details.types';
import { PodiumAccessType } from '../../api/podium.dao';
import { getPodiumAccessType } from '../../components/_events/_manage-event/_connections/_meeting-connections-form/podium-form/podium-form.texts';

type Formatter = (value: unknown) => string;
const settingValueFormatters: Partial<Record<TTemplateSettingKeys, Formatter>> = {
    ['Access Type']: (value: PodiumAccessType) => getPodiumAccessType(value),
};

export const formatBlueprintSettingValue = (
    title: TTemplateSettingKeys,
    value: unknown
): string => {
    const formatter = settingValueFormatters[title];

    if (!formatter) {
        return String(value ?? '');
    }

    return formatter(value);
};